module.exports = __webpack_public_path__ + "img/测评3.e51a5f0c.png";